import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { PointCardUserTemplate } from 'components/Templates'

const PointCardUser: FC = () => {
  return (
    <Layout iconPath={'/icon/white/point_card.svg'} headline={'ポイント付与履歴'} title={'ポイント付与履歴'}>
      <PointCardUserTemplate />
    </Layout>
  )
}

export default PointCardUser
